import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {

  getQuotation: (request) => {
    return axios.post(`${deployPath}/api/apersonal/quotation/`, request)
      .then(quotation => {
        return quotation.data;
      })
      .catch(error => {
        // console.log(error);
      });
  }
};